<div id="goOfflineSyncInProgressContainer">
  <div class="logos-container">
    <div id="snaponLogoContainer" class="logo-container">
      <div id="snaponLogo" class="crm-industrial-font icon-snapon-logo"></div>
    </div>
    <div id="impactLogoContainer" class="logo-container">
      <div id="impactLogo" class="impact-logo">
        <app-icon id="impact-logo" [icon]="appIcon"></app-icon>
      </div>
    </div>
  </div>

  <div id="syncInProgressTextContainer" class="text-container">
    <span class="circle-container"><span class="crm-industrial-font icon-sync-in-progress"></span></span>
    <div id="textContainer" class="messages-container">
      <p id="syncInProgressMessage">{{appStrings.offlineSync_syncInProgressMessage}}</p>
      <p id="readyToUseWhenDoneMessage">{{appStrings.offlineSync_readyToUseWhenDoneMessage}}</p>
    </div>
  </div>

  <div id="buttonContainer" class="button-container">
    <button id="goBackOnlineButton" class="button primary" mat-button (click)="goBackOnline()">
      {{appStrings.button_goBackOnline}}
    </button>
  </div>
</div>
